import React from 'react';
import PageLayout from '../components/PageLayout';

const CancellationRefundPage = () => {
  return (
    <PageLayout title="Cancellation and Refund Policy">
      <p>Last Updated: March 11, 2025</p>

      <h3>Subscription Cancellation</h3>
      <p>
        We understand that circumstances change. You may cancel your
        subscription at any time by following these steps:
      </p>
      <ol>
        <li>Log in to your account on our website</li>
        <li>Navigate to "My Subscription" in your account dashboard</li>
        <li>Click on "Manage Subscription" and select "Cancel Subscription"</li>
        <li>Complete the short cancellation survey</li>
        <li>Confirm your cancellation</li>
      </ol>
      <p>
        Alternatively, you may contact our customer service team at
        <strong> care@curators.studio</strong> or call us at
        <strong> +91 9008789490</strong> to process your cancellation request.
      </p>

      <h3>Cancellation Period</h3>
      <p>
        To avoid being charged for the next billing cycle, please cancel your
        subscription at least 5 business days before your next billing date.
        This allows us sufficient time to process your request and update our
        delivery schedules.
      </p>
      <p>
        If you cancel within the 5-day window before your next billing date, you
        may still be charged for the upcoming month, but you will continue to
        receive deliveries for that period.
      </p>

      <h3>Refund Policy</h3>
      <p>Our refund policy is as follows:</p>
      <ul>
        <li>
          <strong>Quality Issues:</strong> If you receive flowers that do not
          meet our quality standards, please notify us within 24 hours of
          delivery with photos. We will either replace the arrangement or issue
          a credit for that delivery to your account.
        </li>
        <li>
          <strong>Missed Deliveries:</strong> If we fail to deliver your flowers
          on the scheduled day (excluding circumstances beyond our control such
          as adverse weather conditions), we will issue a credit for that
          delivery to your account.
        </li>
        <li>
          <strong>Subscription Cancellation:</strong> If you cancel your
          subscription after being billed for the month, we do not offer
          prorated refunds for the remaining deliveries. You will continue to
          receive deliveries until the end of the current billing cycle.
        </li>
        <li>
          <strong>New Subscribers:</strong> New subscribers may cancel within 48
          hours of their first payment for a full refund if no deliveries have
          been made.
        </li>
      </ul>

      <h3>Credit and Refund Processing</h3>
      <p>
        Account credits will be automatically applied to future deliveries or
        subscription renewals. If you prefer a refund to your original payment
        method instead of account credit, please specify this when contacting
        customer service.
      </p>
      <p>
        Refunds will be processed within 7-10 business days and will be issued
        to the original payment method used for the purchase.
      </p>

      <h3>Special Circumstances</h3>
      <p>
        We understand that special circumstances may arise. If you need to
        temporarily pause your subscription due to vacation, illness, or other
        reasons, please contact our customer service team at least 7 days in
        advance, and we'll be happy to accommodate your request.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions about our Cancellation and Refund Policy,
        please contact us:
      </p>
      <p>
        Email: care@curators.studio
        <br />
        Phone: +91 9008789490
        <br />
        Hours: Monday to Friday, 9:00 AM to 6:00 PM IST
      </p>
    </PageLayout>
  );
};

export default CancellationRefundPage;
